/**
 * hopeStabilityEngine.js
 *
 * Detects when a response risks superficial optimism (triunfalismo)
 * and calibrates toward sober, grounded hope.
 *
 * DISTINCT from responseBoundaryEngine (which suppresses miracle promises).
 * This engine detects HOPE DEPTH risk from user message patterns and installs
 * a calibration instruction so the LLM responds with rooted, not shallow, hope.
 *
 * Sober hope = honest about difficulty + anchored in deeper reality.
 * Triunfalismo = quick resolution, easy assurance, spiritual bypass.
 */

const TRIUNFALISM_RISK_TRIGGERS = [
  /¿(?:habrá|hay)\s+(?:alguna\s+)?esperanza/i,
  /ya\s+no\s+(?:tengo|veo)\s+esperanza/i,
  /¿(?:para\s+qué|vale\s+la\s+pena)\s+(?:seguir|orar|esforzarse)/i,
  /no\s+hay\s+salida/i,
  /¿(?:dios|Dios)\s+(?:me\s+escucha|está\s+ahí|me\s+ve)/i,
  /perdí\s+la\s+fe/i,
  /¿(?:tiene|tendrá)\s+solución/i,
  /sin\s+salida/i,
];

/**
 * @param {{
 *   text:      string,
 *   emotion:   object|null,
 *   mood:      string,
 *   riskLevel: string,
 * }} params
 * @returns {{
 *   needsCalibration: boolean,
 *   instruction:       string|null,
 * }}
 */
export function assessHopeStability({ text, emotion, mood, riskLevel }) {
  const hasHopeTrigger = TRIUNFALISM_RISK_TRIGGERS.some((p) => p.test(text ?? ""));

  const isVulnerableEmotionally =
    ["discouragement", "fear", "loneliness", "grief", "spiritual_confusion"]
      .includes(emotion?.dominantEmotion);

  const isHighRiskContext =
    riskLevel === "high" || riskLevel === "critical" || mood === "grief";

  if (hasHopeTrigger || isVulnerableEmotionally || isHighRiskContext) {
    return {
      needsCalibration: true,
      instruction:
        "Evita optimismo superficial y triunfalismo espiritual. " +
        "La esperanza pastoral es tranquila, arraigada, honesta con el dolor.",
    };
  }

  return { needsCalibration: false, instruction: null };
}
